const LOCALE = 'ru-RU';

const rtf = new Intl.RelativeTimeFormat(LOCALE, { numeric: 'auto' });

export function relative(date: Date, now = new Date()): string {
  const diff = (date.getTime() - now.getTime()) / 1000;
  const abs = Math.abs(diff);
  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ['year', 31536000],
    ['month', 2592000],
    ['day', 86400],
    ['hour', 3600],
    ['minute', 60],
    ['second', 1],
  ];
  for (const [unit, sec] of units) {
    if (abs >= sec || unit === 'second') return rtf.format(Math.round(diff / sec), unit);
  }
  return '';
}

/** Форматы <t:unix:STYLE> так, как их показывает Discord в русской локали. */
export function discordTimestamp(unix: number, style = 'f'): string {
  const d = new Date(unix * 1000);
  if (Number.isNaN(d.getTime())) return 'Invalid Date';
  switch (style) {
    case 't':
      return d.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit' });
    case 'T':
      return d.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    case 'd':
      return d.toLocaleDateString(LOCALE, { day: '2-digit', month: '2-digit', year: 'numeric' });
    case 'D':
      return d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' });
    case 'F':
      return d.toLocaleString(LOCALE, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    case 'R':
      return relative(d);
    case 's':
      return d.toLocaleString(LOCALE, { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    case 'S':
      return d.toLocaleString(LOCALE, { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    case 'f':
    default:
      return d.toLocaleString(LOCALE, { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  }
}

export const TIMESTAMP_STYLES: { style: string; label: string }[] = [
  { style: 't', label: 'Короткое время' },
  { style: 'T', label: 'Время с секундами' },
  { style: 'd', label: 'Короткая дата' },
  { style: 'D', label: 'Длинная дата' },
  { style: 'f', label: 'Дата и время' },
  { style: 'F', label: 'День недели, дата и время' },
  { style: 'R', label: 'Относительное' },
];

function sameDay(a: Date, b: Date) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

/** «Сегодня, в 16:20» / «Вчера, в 16:20» / «20.04.2021 16:20» - как в шапке сообщения и футере эмбеда. */
export function calendarTime(date: Date, now = new Date()): string {
  const time = date.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit' });
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  if (sameDay(date, now)) return `Сегодня, в ${time}`;
  if (sameDay(date, yesterday)) return `Вчера, в ${time}`;
  if (sameDay(date, tomorrow)) return `Завтра, в ${time}`;
  return `${date.toLocaleDateString(LOCALE, { day: '2-digit', month: '2-digit', year: 'numeric' })} ${time}`;
}
